import { COIConflictMatch } from "./ConflictCheckResults.types";

export const affiliateDisplayName = (match: COIConflictMatch): string =>
  match.AffiliateTypeCode === "EN"
    ? match.AffiliateEntityName || ""
    : [match.AffiliateFirstName, match.AffiliateMiddleName, match.AffiliateLastName].filter(Boolean).join(" ");

export const resolvePageIds = (
  pageOption?: { clientMasterId?: number; processedTemplateId?: number }
): { clientMasterId?: number; processedTemplateId?: number } => {
  if (pageOption?.clientMasterId) {
    return pageOption;
  }

  const params = new URLSearchParams(window.location.search);
  const clientMasterId = params.get("clientMasterId");
  const processedTemplateId = params.get("processedTemplateId");

  return {
    clientMasterId: clientMasterId ? Number(clientMasterId) : undefined,
    processedTemplateId: processedTemplateId ? Number(processedTemplateId) : undefined,
  };
};
